import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'persons-list',
    name: 'personData',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'personList',
        component: () => import('../pages/PersonListPage.vue')
      },
      {
        path: ':personId',
        name: 'personDetailsContainer',
        props: true,
        component: () => import('../pages/PersonDetailsContainerPage.vue'),
        children: [
          {
            path: '',
            component: () => import('../pages/PersonDetailsPage.vue'),
            name: 'personDetailsPage',
            props: true,
            children: [
              {
                path: '',
                name: 'personDetails',
                component: () => import('../relations/person-details/pages/PersonDetailsDetailsPage.vue'),
                props: true
              },
              {
                path: 'qualifications',
                name: 'qualifications',
                component: () => import('../relations/qualification/pages/QualificationListPage.vue'),
                props: true
              },
              {
                path: 'contracts',
                name: 'contracts',
                component: () => import('../relations/contract/pages/ContractListPage.vue'),
                props: true
              },
              {
                path: 'absences',
                name: 'absences',
                component: () => import('../relations/absence/pages/AbsenceListPage.vue'),
                props: true
              },
              {
                path: 'reduced-work-schedules',
                name: 'reducedWorkSchedules',
                component: () => import('../relations/reduced-work-schedule/pages/ReducedWorkScheduleListPage.vue'),
                props: true
              },
              {
                path: 'person-education-locations',
                name: 'personEducationLocations',
                component: () => import('../relations/person-has-education-location/pages/PersonHasEducationLocationListPage.vue'),
                props: true
              },
              {
                path: 'person-courses',
                name: 'personCourses',
                component: () => import('../relations/person-has-course/pages/PersonHasCourseListPage.vue'),
                props: true
              },
              {
                path: 'educations',
                name: 'educationList',
                props: true,
                children: [
                  {
                    path: '',
                    name: 'educations',
                    component: () => import('../relations/education/pages/EducationListPage.vue'),
                    props: true
                  },
                  {
                    path: ':educationId',
                    name: 'educationProgressTemplate',
                    component: () => import('../relations/education-progress/pages/EducationProgressPage.vue'),
                    props: true
                  }
                ]
              },
              {
                path: 'tutor-reports',
                name: 'tutorReports',
                component: () => import('../relations/tutor-report/pages/TutorReportListPage.vue'),
                props: true
              },
              {
                path: 'tutor-payouts',
                name: 'tutorPayouts',
                component: () => import('../relations/tutor-report/pages/TutorPayoutListPage.vue'),
                props: true
              },
              {
                path: 'person-part-exams',
                name: 'personPartExams',
                component: () => import('../relations/person-has-part-exam/pages/PersonHasPartExamListPage.vue'),
                props: true
              },
              {
                path: 'person-payments',
                name: 'personPayments',
                component: () => import('../relations/person-has-payment/pages/PersonHasPaymentListPage.vue'),
                props: true
              },
              {
                path: 'person-education-elements',
                name: 'personEducationElements',
                component: () => import('../relations/person-has-education-element/pages/PersonHasEducationElementListPage.vue'),
                props: true
              }
            ]
          }
        ]
      }
    ]
  }
];

export default routes;
